import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from '../../services/shared/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

  isLoading: Subject<boolean>

    constructor(private loaderService: LoaderService) {
        this.isLoading = this.loaderService.isLoading;
  }

  ngOnInit(): void {
  }

}
